import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import AshieyLipPiercingImage from '../../Assets/Piercing Services/ashiey lip piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function AshieyLipPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Ashiey Lip Piercing UAE | 200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Ashiey Lip Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Ashiey Lip Piercing 200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={AshieyLipPiercingImage} alt="Ashiey Lip Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Ashiey Lip Piercing</h3>

          <p>
            Enhance your facial style with our professional Ashley lip piercing services in the UAE, available at an affordable price of 200 AED. Ashley lip piercing is a unique and eye-catching style placed at the center of the lower lip, creating a bold yet elegant look that highlights your natural features. Unlike traditional lip piercings, the Ashley piercing has a single visible point on the outside, giving it a clean and minimal aesthetic while maintaining a strong visual impact. This makes it a popular choice for individuals who want a modern, stylish, and distinctive piercing that stands out while still appearing refined. Whether you prefer a subtle stud or a decorative gemstone, our expert specialists ensure precise placement for a perfectly balanced and aesthetically pleasing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each Ashley lip piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Lip piercings require special attention due to the sensitivity of the area, and our experienced specialists use advanced techniques to reduce discomfort and make the procedure as quick and efficient as possible.
          </p>

          <p>
            Ashley lip piercing is ideal for individuals who want a bold yet minimalistic look that enhances their facial symmetry. Its central placement draws attention to the lips, making it a perfect choice for those who want a subtle yet striking feature. This piercing pairs well with other facial piercings or can stand alone as a statement piece. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry options to suit your style and comfort.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for clients with busy schedules. We provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process. Our goal is to deliver a safe, stylish, and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that lip piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your Ashley lip piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions to avoid infection or irritation. Following proper aftercare ensures faster healing and helps maintain the health and appearance of your piercing.
          </p>

          <p>
            Our Ashley lip piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted Ashley lip piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a unique and elegant look effortlessly. Book your Ashley lip piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Ashiey Lip Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AshieyLipPiercing;